import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get purchaseOrder
export const getPurchaseOrder = createAsyncThunk(
  "purchaseOrder/getPurchaseOrder",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getPurchaseOrder({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all purchaseOrder
export const getAllPurchaseOrder = createAsyncThunk(
  "purchaseOrder/getAllPurchaseOrder",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllPurchaseOrder();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("purchaseOrder/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("purchaseOrder/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "purchaseOrder/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPagePurchaseOrder({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get purchaseOrder by additional charge
export const getPurchaseOrderAdditionalChargeList = createAsyncThunk(
  "purchaseOrder/getPurchaseOrderAdditionalChargeList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseOrderAdditionalChargeList();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const getPurchaseOrderChargeStatus = createAsyncThunk(
  "purchaseOrder/getPurchaseOrderChargeStatus ",
  async (type, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseOrderChargeStatus(type);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get item by id
export const getPurchaseOrderById = createAsyncThunk(
  "purchaseOrder/getPurchaseOrderById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseOrderById(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get item by id
export const getSaleOrderDetail = createAsyncThunk(
  "purchaseOrder/getSaleOrderDetail",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleOrderDetail(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create purchaseOrder
export const createPurchaseOrder = createAsyncThunk(
  "purchaseOrder/createPurchaseOrder",
  async (createData, { rejectWithValue }) => {
    const {
      purchaseOrderDetails,
      purchaseOrderMainAdditionalChargeCost,
      partyAccount,
      voucherDate,
      voucherDateBs,
      narration,
      branch,
      purchaseOrderMainPartyDetails,
      purchaseOrderMainVehicleDetail,
      discountAmount,
      grandTotal,
      vatAmount,
    } = createData;
    try {
      const body = JSON.stringify({
        purchaseOrderDetails,
        purchaseOrderMainAdditionalChargeCost,
        partyAccount,
        voucherDate,
        voucherDateBs,
        narration,
        branch,
        purchaseOrderMainPartyDetails,
        purchaseOrderMainVehicleDetail,
        discountAmount,
        grandTotal,
        vatAmount,
      });
      const { data } = await API.createPurchaseOrder(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updatePurchaseOrder = createAsyncThunk(
  "purchaseOrder/updatePurchaseOrder",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const {
      salesOrder,
      indentNo,
      isFromHo,
      requiredDateAd,
      voucherDate,
      voucherDateBs,
      branch,
      status,
      documentsAttach,
      // refVoucher,
      purchaseOrderDetails,
      purchaseOrderMainPartyDetails,
      purchaseOrderMainVehicleDetail,
    } = values;
    try {
      const body = JSON.stringify({
        salesOrder,
        indentNo,
        isFromHo,
        requiredDateAd,
        branch,
        status,
        voucherDate,
        voucherDateBs,
        // refVoucher,
        purchaseOrderDetails,
        purchaseOrderMainPartyDetails,
        purchaseOrderMainVehicleDetail,
      });
      const { data } = await API.updatePurchaseOrder(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "purchaseOrder/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
